<script setup>
import ContentCard from "@/app/components/common/ContentCard.vue";
import { ref } from "vue";

/* eslint-disable no-undef */
defineProps({
  noBox: {
    type: Boolean,
    default: false,
  },
});

const showImage = ref(true);
</script>

<template>
  <section class="section section-with-divider">
    <h2>Sound-Therapie-Raum</h2>

    <img
        v-if="showImage"
        :src="require('@/assets/images/SoundRaum.jpeg')"
        alt="Sound-Therapie-Raum"
        @error="showImage = false"
        class="therapist-image"
    />

    <ContentCard
        :no-box="noBox"
    >
      <template v-slot:description>
        <p>
          In der Praxis steht ein speziell eingerichteter Sound-Therapie-Raum zur Verfügung,
          der als ergänzender Bestandteil der psychotherapeutischen Arbeit genutzt wird.
          Der Raum ist fest installiert und wurde von einem Tonmeister nach professionellen
          akustischen und psychotherapeutischen Maßstäben konzipiert.
        </p>
        <p>
          Mehrere präzise platzierte Lautsprecher erzeugen ein immersives,
          mehrkanaliges Klangfeld.
          Diese besondere akustische Umgebung ermöglicht eine bilaterale auditive
          Stimulation, die gezielt zur Beruhigung und Regulation des Nervensystems
          eingesetzt wird. Über gezielte Entspannung wird die Verarbeitung innerer
          Prozesse unterstützt und die Integration therapeutischer Inhalte vertieft.
        </p>
        <p>
          Die Sound-Therapie kommt insbesondere im Anschluss an intensive therapeutische
          Sitzungen zum Einsatz. Viele Menschen erleben diese Form der Klangarbeit als
          stabilisierend, ordnend und nachhaltig entlastend.
        </p>
        <p>
          Die Sound-Therapie ersetzt keine psychotherapeutische Behandlung,
          sondern wird ergänzend eingesetzt.
        </p>
      </template>
    </ContentCard>
  </section>
</template>

<style scoped>
.section h2 {
  text-align: left;
  font-size: var(--font-size-xxl);
  color: var(--color-cream);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);
  margin: 0 0 var(--spacing-sm) 0;
}

.therapist-image {
  max-width: 320px;
  width: 100%;
  height: auto;
  border-radius: var(--box-border-radius);
  display: block;

  transition: transform var(--transition-normal),
  box-shadow var(--transition-normal);
}

.therapist-image:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  transition: transform var(--transition-normal),
  box-shadow var(--transition-normal);
}

.info-list li::before {
  content: "✓";
  color: var(--color-cream-dark);
}

@media (min-width: 1024px) {
  .section {
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .section h2 {
    grid-column: 1 / -1;
  }

  .therapist-image {
    max-width: 280px;
  }

  .section :deep(.content-card) {
    margin-top: 0;
    padding-top: 0;
  }
}

@media (max-width: 768px) {
  .therapist-image {
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .therapist-image {
    max-width: 240px;
    align-self: center;
  }
}
</style>
